// extracted by mini-css-extract-plugin
module.exports = {"benefits":"Checkin_benefits__2tSX5","benefit":"Checkin_benefit__2Ic9L","divider":"Checkin_divider__2qZiR"};